import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import MathJax from "react-mathjax4";
import { useStyles, useTranslations } from "sdk/custom-hooks";
import { useSelector, useDispatch } from "react-redux";
import { toggleMarkForReview } from "sdk/actions";
import { editor } from "sdk/common";
import { Button, Box, Modal, IconButton } from "@material-ui/core";
import { ColorsConstant } from "../../../constants/colorConstant";
import LongMenu from "../../longMenu";
import pauseImage from "../../../assets/images/pauseImage.png";
import ReviewCheck from "../../../assets/images/ReviewCheck.png";
import ReviewUncheck from "../../../assets/images/ReviewUncheck.png";
import CloseIcon from "@material-ui/icons/Close";
import ZoomInIcon from "@material-ui/icons/ZoomIn";
import ZoomOutIcon from "@material-ui/icons/ZoomOut";
 
/**
* Question title.
* @param props
* @returns {*}
* @constructor
*/
function QuestionTitle(props) {
  const {
    number,
    title,
    localesTitle,
    direction,
    localesDirection,
    questionMark,
    mark,
    classNameInView,
    viewMode,
    timeSpent,
    penalty,
    isPdf,
    mode,
    handleQuizPauseChange,
    pauseQuiz,
    setPauseQuiz,
    directionData,
    type,
  } = props;
  editor(title);
  const classes = useStyles(styles)();
  const t = useTranslations();
  const dispatch = useDispatch();
  const selectedQuestion = useSelector((state) => state.selectedQuestion);
  const markButtonActive = selectedQuestion ? selectedQuestion.marked : false;
  const ModelOpen = false;
  const [open, setOpen] = useState(false);
  const [imgSrc, setImgSrc] = useState("");
  const [zoom, setZoom] = useState(1);
  const mathRef = useRef(null);

useEffect(() => {
  if (mathRef.current) {
    const images = mathRef.current.querySelectorAll("img");
    images.forEach((img) => {
      img.style.cursor = "pointer";
      img.onclick = () => {
        setImgSrc(img.src);
        setZoom(1);
        setOpen(true);
      };
    });
  }
}, [title, localesTitle]); // Trigger effect when MathJax content changes

const handleZoomIn = () => setZoom((z) => Math.min(z + 0.2, 3));
const handleZoomOut = () => setZoom((z) => Math.max(z - 0.2, 0.5));

  function quizPauseChange(value) {
    setPauseQuiz(!pauseQuiz);
    handleQuizPauseChange(value);
  }

  function toggleMarkForReviewFn() {
    dispatch(toggleMarkForReview());
  }
  return (
    <>
      <Box className={classes.englangOption}>
        <Box component="inherit" className={classes.markForReviewMobile}>
              <IconButton
                aria-label={t("Review")}
                onClick={toggleMarkForReviewFn}
                className={classes.reviewToggleButton}
              >
                <img alt="" src={markButtonActive ? ReviewCheck : ReviewUncheck} />
              </IconButton>
          <label id="radio">{t("Review")}</label>
        </Box>
        {mode !== 'live-test' && <Box className={classes.pauseAndReport}>
            <Box className={classes.pauseAndFeedbackAlignMobile}>
              <Button className={classes.pauseButton} onClick={() => quizPauseChange(!ModelOpen)} variant="outlined">
                <img src={pauseImage} alt="pauseImage" />
                <span className={classes.pauseText}>Pause</span>
              </Button>
              <LongMenu
                isIconButtonComponent={false}
                question={selectedQuestion}
              />
            </Box>
        </Box>}
        <Box className={classes.queTagBold}>                    
              <Box className={classes.marksDistribution}>
                <Box className={classes.marksContainer}>
                  {viewMode ? (
                    !isPdf && (
                      <>
                        <Box className={classes.marksCount}>
                          <span className={classes.totalMarksContainer + ' ' + classNameInView}>{mark} </span>
                        </Box>
                        <Box className={classes.marksCount}>
                          <span className={classes.marksBadges}>{timeSpent} </span>
                        </Box>
                      </>
                    )
                  ) : (
                    <Box className={classes.marksCount}>
                      <span className={classes.totalMarksContainer}>  + {questionMark} </span>
                      <span className={classes.totalMarksContainer + ' ' + classes.deduct}>  - {penalty} </span>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
      </Box>
      <Box className={classes.questionText}>
        <Box className={classes.englishQuestionText}>
          <Box>
            {selectedQuestion?.id?.directionId && directionData[selectedQuestion?.id?.directionId] && (
              <Box
                key={selectedQuestion?.id?.directionId}
                dangerouslySetInnerHTML={{ __html: directionData[selectedQuestion?.id?.directionId] }}
              />
            )}
          </Box>
          {type === 'MultiChoice' && <span className={classes.multipleText}>*{t('You can select more than one option')}</span>}
          <Box style={{ display: 'flex', alignItems: 'inherit' }}>
            <span className={classes.queTagBold}>
              {!localesTitle || localesTitle === title ? "Q." + number : ""}{" "}
            </span>

            {direction?.direction ? (
              <Box className={classes.hiddenSm}>
                <h4>
                  <MathJax.Context input="tex">
                    <MathJax.Html html={direction.direction || localesDirection} />
                  </MathJax.Context>
                </h4>
              </Box>
            ) : null}
            <span
              className={
                !localesTitle || localesTitle !== title
                  ? "mathjax-line"
                  : "mathjax-line-space"
              }
            >
              {direction?.type === "SHORT_TEXT" ? (
                <h4 className="web-hindi-text">
                  <MathJax.Context input="tex">
                    <MathJax.Html html={direction?.direction || localesDirection} />
                  </MathJax.Context>
                </h4>
              ) : null}
              <div ref={mathRef}>
                <MathJax.Context input="tex">
                  <MathJax.Html html={localesTitle || title} />
                </MathJax.Context>
              </div>

              <Modal open={open} onClose={() => setOpen(false)}>
                <Box className={classes.modalWrapper}>
                  <IconButton className={classes.closeButton} onClick={() => setOpen(false)}>
                    <CloseIcon style={{ color: "white" }} />
                  </IconButton>
                  <IconButton className={classes.zoomInButton} onClick={handleZoomIn}>
                    <ZoomInIcon style={{ color: "white" }} />
                  </IconButton>
                  <IconButton className={classes.zoomOutButton} onClick={handleZoomOut}>
                    <ZoomOutIcon style={{ color: "white" }} />
                  </IconButton>

                  <Box className={classes.modalContent}>
                    <img
                      src={imgSrc}
                      alt="Zoomable"
                      className={classes.modalImage}
                      style={{ transform: `scale(${zoom})` }}
                    />
                  </Box>
                </Box>
              </Modal>

            </span>
          </Box>
        </Box>
      </Box>
    </>
  );
}
 
const styles = (theme) => ({
  hiddenSm: {
    display: "none",
  },
  pauseText: {
    "@media (min-width: 768px)": {
      paddingLeft: "12px",
    },
  },
  pauseAndFeedbackAlignMobile: {
    display: "flex",
  },
  multipleText: {
    color: "#F75151",
    position: "absolute",
    fontSize: "12px",
    fontStyle: "italic",
    marginTop: "-15px",
    marginBottom: "45px",
    fontWeight: "300",
    lineHeight: "15px",
    minHeight: "15px",
  },
  questionText: {
    "-webkit-user-select": "none",
    "-webkit-touch-callout": "none",
    "-moz-user-select": "none",
    "-ms-user-select": "none",
    "user-select": "none",
    float: "left",
    textAlign: "left",
    width: "calc(100% - 20px)",
    padding: 10,
    position: "relative",
    lineHeight: "22px",
    fontWeight: 400,
    color: ColorsConstant.descriptionColor,
    "& .MathJax_Display": {
      display: "contents !important",
    },
    "& .web-hindi-text": {
      fontWeight: "bold",
    },
    "@media (min-width: 280px) and (max-width: 767px)": {
      padding: "10px 0",
      width: "90%",
      overflowWrap: "break-word",
      fontSize: "15px",
      paddingLeft: "20px",
    },
  },
  queTagBold: {
    fontSize: "16px",
    display: 'flex',
    marginTop: '1em',
    fontWeight: "500",
    marginRight: 10,
    color: "#202020",
    "@media (min-width:280px) and (max-width:767px)": {
      fontSize: "18px",
    },
  },
  englishQuestionText: {
    width: "100%",
    padding: 0,
    float: "left",
    paddingLeft: "40px",
    fontSize: "16px !important",
    display: "flex",
    alignItems: "baseline",
    flexDirection:"column",
    "@media (min-width:280px) and (max-width:767px)": {
      alignItems: "baseline",
      fontSize: "18px",
      padding: "0px",
    },
    "& span": {
      "& div": {
        "& p": {
          "& img": {
            width: "40%",
            height: "auto",
            display: "block",
            margin: "16px 0px",
            cursor: "pointer",
            "@media (max-width: 767px)": {
              width: "100%",
            },
          },
        },
      },
    },
  },
  totalMarksContainer: {
    padding: "2px 6px",
    color: "#FAFAFA",
    backgroundColor: "#3FA159",
    fontWeight: "bold",
    borderRadius: 2,
    fontSize: 13,
    display: "flex",
    border: "1px solid #FFF",
    "@media (min-width:320px) and (max-width:1024px)": {
      paddingLeft: 5,
      paddingRight: 5,
    },
    "@media (min-width:320px) and (max-width:767px)": {
      fontSize: 11,
    },
  },
  deduct: {
    backgroundColor: "#AC3C2B",
    fontWeight: "bold",
    marginLeft: 15,
    color: "#FAFAFA",
    border: "1px solid #AC3C2B",
  },
  marksCount: {
    marginRight: 10,
    display: "flex",
  },
  marksBadges: {
    backgroundColor: "#ffc65820",
    color: "#ffc658",
    border: "1px solid #ffc658",
    borderRadius: 2,
    padding: "2px 6px",
    fontSize: 13,
    textAlign: "center",
    whiteSpace: "nowrap",
    marginRight: 0,
    display: "flex",
  },
  marksContainer: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    marginLeft: 5,
  },
  markForReviewMobile: {
    display: 'flex',
    gap: '10px',
    paddingRight: 46,
    borderRadius: 5,
    textAlign: "center",
    fontSize: 16,
    cursor: "pointer",
    "& input": {
      width: 20,
      height: 20,
      marginRight: 5,
      top: 1,
      cursor: "pointer",
    },
    "@media (min-width:280px) and (max-width:767px)": {
      alignItems: "center",
      justifyContent: "center",
    },
  },
  reviewToggleButton: {
    padding: 0,
  },
  pauseAndReport: {
    display: "flex",
    alignItems: "center",
    gap: "14px",
  },
  pauseButton: {
    color: "#0C3450",
    fontSize: "18px",
    fontStyle: "normal",
    textAlign: "center",
    fontWeight: "400",
    lineHeight: "113.5%",
    border: "1px solid #E7E7E7",
    textTransform: "capitalize",
    background: "#FFF",
    boxShadow: "4px 4px 8px 0px rgba(198, 198, 198, 0.25)",
    margin: "9px",
    position: "relative",
    right: "15%",
    display: "none",
  },
  englangOption: {
    padding: '20px 40px 0px',
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "center",
    "@media (min-width:280px) and (max-width:767px)": {
      marginTop: 15,
      padding: '0 10px',
    },
    color: "#0C3450",
    textAlignLast: "left",
    fontSize: "20px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "113.5%",
    "& div": {
      "&.MuiSelect-selectMenu": {
        border: "1px solid #E7E7E7",
 
        background: "#FFF",
        color: "#0C3450",
        textAlign: "center",
        fontSize: "15px",
        fontStyle: "normal",
        fontWeight: "400",
        lineHeight: "113.5%",
      },
    },
  },
  modalWrapper: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.95)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        zIndex: 1300,
    },
    modalContent: {
        maxWidth: "90vw",
        maxHeight: "90vh",
        overflow: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    modalImage: {
        transition: "transform 0.2s ease-in-out",
        maxWidth: "100%",
        maxHeight: "100%",
    },
    closeButton: {
        position: "absolute",
        top: 20,
        right: 20,
    },
    zoomInButton: {
        position: "absolute",
        top: 20,
        right: 70,
    },
    zoomOutButton: {
        position: "absolute",
        top: 20,
        right: 120,
    },
});

QuestionTitle.propTypes = {
  number: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  localesTitle: PropTypes.string,
  direction: PropTypes.shape({
    type: PropTypes.string,
    direction: PropTypes.string,
  }),
  localesDirection: PropTypes.string,
  questionMark: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  mark: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  classNameInView: PropTypes.string,
  viewMode: PropTypes.bool,
  timeSpent: PropTypes.string,
  penalty: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isPdf: PropTypes.bool,
  mode: PropTypes.string,
  handleQuizPauseChange: PropTypes.func,
  pauseQuiz: PropTypes.bool,
  setPauseQuiz: PropTypes.func,
  directionData: PropTypes.object,
  type: PropTypes.string,
};

export default QuestionTitle;